import React from "react";
import { ClickButton } from "components/FormElements";

type ModalAttributesTypes = {
  handleClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  handleCancel?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  title?: string;
  subtitle?: string;
  clickLabel: string;
};

export default function Modal({ title, subtitle, clickLabel, handleClick, handleCancel }: ModalAttributesTypes) {
  return (
    <div className="fixed flex justify-center items-center inset-0 overflow-y-auto z-50 h-full w-full bg-black" id="modal">
      <div className="flex flex-col justify-center text-white">
        <h1 className="text-3xl text-center mb-3">{title}</h1>
        <p className="whitespace-pre-line">{subtitle}</p>
        <div className="grow-0 flex justify-center mt-4">
          <ClickButton handleClick={handleClick} label={clickLabel} colour="bg-ct-yellow" />
        </div>
        {handleCancel && <ClickButton handleClick={handleCancel} label={clickLabel} />}
      </div>
    </div>
  );
}
